import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_PAGE_WIDTH } from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  globalSearch: {
    width: '100%',
  },
  globalSearchResult: {
    zIndex: 1000,
    [theme.breakpoints.down('md')]: {
      width: '100vw !important',
    },
  },
  globalSearchResultPaper: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
  globalSearchResultItem: {
    padding: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    border: `1px solid transparent`,
    borderRadius: '10px',

    '&:hover': {
      cursor: 'pointer',
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
  globalSearchResultCategoryName: {
    ...theme.mixins.appLabel,
    padding: theme.spacing(1, 1, 0, 2),
  },
}));
